<template>
	<polar-area 
	:height="height"
	:chart-data="data" 
	:chart-options="options" />
</template>

<script>  

	import { PolarArea } from 'vue-chartjs/legacy'

	import { 
		Chart as ChartJS, 
		Title, 
		Tooltip, 
		Legend, 
		BarElement, 
		CategoryScale, 
		LinearScale 
	} from 'chart.js'

	ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

	export default { 

		props: {

			height: {
				type: Number,
				default: 300
			},

			chartData: {
				type: Object,
				default: () => {}
			}, 

			options: {
				type: Object,
				default: () => {}
			}

		},

		components: {
			PolarArea,
		},

		computed: {
			data() {
				return this.chartData ? this.chartData : {}
			}
		}

	}

</script> 